/* styles.ts */
import styled from "styled-components";

/**
 * Container principal para o card expandido.
 */
export const ExpandedCardContainer = styled.div`
  transition: all 0.3s ease-in-out;
  grid-template-rows: minmax(0, 1fr) auto;
  display: grid;
  width: 100%;
  min-width: 0;
  min-height: 0;
  height: 100%;
  overflow: hidden;

  @media (max-width: 450px) {
    width: 100%;

    & * {
      font-size: 0.7rem; /* Reduz o tamanho da fonte proporcionalmente */
    }
    .icon,
    img,
    svg {
      transform: scale(0.9);
      transform-origin: center; /* Mantém centralizado */
    }

    padding: 0;
    margin: 0;
  }
`;

export const ExpandedCardScrollable = styled.div`
  padding: ${({ theme }) => theme.spacing(1)};
  padding-bottom: ${({ theme }) => theme.spacing(3)};
  gap: ${({ theme }) => theme.spacing(3)};
  flex: 1 1 auto;
  min-height: 0;
  flex-direction: column;
  overflow-x: hidden;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  overscroll-behavior: contain;
  display: flex;
`;
